module.exports = __webpack_public_path__ + "static/media/liveroom-app-top-bg.789d9884.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/liveroom-app-top-bg.png
// module id = 2017
// module chunks = 6